export default __webpack_public_path__ + "static/media/no_image_placeholder.bc4d69a9.png";